/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

// แสดงแทนเนื้อหาเมื่อ fetch ตอนเปิดหน้า fail — กันหน้าโชว์สถานะหลอก
// (เช่น "ไม่พบข้อมูลการสมัคร" / ฟอร์มเปล่า) ทั้งที่จริงแค่โหลดไม่สำเร็จ
const LoadError = ({ className = 'content', message = 'โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', onRetry }) => (
  <div className={className} role="alert">
    <div>
      <h3>{message}</h3>
      <a className="btn-main cursor-pointer" onClick={onRetry || (() => window.location.reload())}>
        {'โหลดใหม่'}
      </a>
    </div>
  </div>
);

export default LoadError;
